import se from "../InAppMessage/in-app-message-manager-factory.js";
import r, { OPTIONS as z } from "../managers/braze-instance.js";
import gr from "./triggers-provider.js";
export var TriggersProviderFactory = {
  i: !1,
  provider: null,
  o: function o() {
    return TriggersProviderFactory.t(), TriggersProviderFactory.provider || TriggersProviderFactory.rg(), TriggersProviderFactory.provider;
  },
  rg: function rg() {
    if (!TriggersProviderFactory.provider) {
      var i = r.ee(z.Zo);
      TriggersProviderFactory.provider = new gr(null != i ? i : 30, se.ea()._i(), r.p(), r.nn(), se.ea()), r.v(TriggersProviderFactory.provider);
    }
  },
  t: function t() {
    TriggersProviderFactory.i || (TriggersProviderFactory.rg(), r.g(TriggersProviderFactory), TriggersProviderFactory.i = !0);
  },
  destroy: function destroy() {
    TriggersProviderFactory.provider = null, TriggersProviderFactory.i = !1;
  }
};